import {AudioPresets} from "livekit-client";

const AGENT_CALL_AUDIO_BITRATE_KEY = "frecall-agent-call-audio-bitrate-kbps";
const DATA_SAVER_BITRATE_KBPS = 24;
const HIGH_FIDELITY_BITRATE_KBPS = 48;

const normalizeCallAudioBitrateKbps = (value) =>
  Number(value) === DATA_SAVER_BITRATE_KBPS ?
    DATA_SAVER_BITRATE_KBPS : HIGH_FIDELITY_BITRATE_KBPS;

const readAgentCallAudioBitrateKbps = () => {
  if (typeof window === "undefined") return HIGH_FIDELITY_BITRATE_KBPS;
  return normalizeCallAudioBitrateKbps(
      window.localStorage.getItem(AGENT_CALL_AUDIO_BITRATE_KEY),
  );
};

const saveAgentCallAudioBitrateKbps = (value) => {
  const bitrate = normalizeCallAudioBitrateKbps(value);
  window.localStorage.setItem(AGENT_CALL_AUDIO_BITRATE_KEY, String(bitrate));
  return bitrate;
};

const callAudioPublishDefaults = (value) => ({
  audioPreset: normalizeCallAudioBitrateKbps(value) ===
    DATA_SAVER_BITRATE_KBPS ? AudioPresets.speech : AudioPresets.music,
  // Preserve silence savings and packet-loss protection in both modes.
  dtx: true,
  red: true,
});

export {
  AGENT_CALL_AUDIO_BITRATE_KEY,
  DATA_SAVER_BITRATE_KBPS,
  HIGH_FIDELITY_BITRATE_KBPS,
  callAudioPublishDefaults,
  normalizeCallAudioBitrateKbps,
  readAgentCallAudioBitrateKbps,
  saveAgentCallAudioBitrateKbps,
};
